import { clsx } from 'clsx';
import type { InputHTMLAttributes } from 'react';

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  error?: string;
  description?: string;
};

export const Input = ({ label, error, description, className, id, ...props }: InputProps) => {
  const inputId = id ?? label?.toLowerCase().replace(/\s+/g, '-');

  return (
    <div className="grid gap-1.5">
      {label && (
        <label htmlFor={inputId} className="text-sm font-medium text-text-secondary">
          {label}
        </label>
      )}
      <input
        id={inputId}
        className={clsx(
          'w-full rounded-lg border border-border px-3 py-2 text-text',
          'placeholder:text-disabled-text',
          'focus:border-button-outline-border focus:outline-none focus:ring-1 focus:ring-focus-ring',
          'disabled:cursor-not-allowed disabled:bg-disabled-bg disabled:text-disabled-text',
          error && 'border-error focus:border-error focus:ring-error',
          className,
        )}
        {...props}
      />
      {description && !error && <p className="text-sm text-text-secondary">{description}</p>}
      {error && <p className="text-sm text-error">{error}</p>}
    </div>
  );
};
